/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

/*
    Announcement bar
*/
document.addEventListener('shopify:block:select', (event) => {
    const carousel = event.target.closest('.announcement-bar .carousel')

    if (carousel) {
        bootstrap.Carousel.getOrCreateInstance(carousel, { ride: false })
            .to(event.target.dataset.index)
    }
})

/*
    Carousel
*/
document.addEventListener('shopify:block:select', (event) => {
    const carousel = event.target.closest('.carousel')

    if (carousel) {
        bootstrap.Carousel.getOrCreateInstance(carousel, { ride: false })
            .to(event.target.dataset.index)
    }
})

/*
    Ingredient Slider
*/
const initIngredientSlider = () => {
    document.querySelectorAll('.ingredient-slider').forEach(section => {
        const element = section.querySelector('.splide')

        const mySplide = new Splide(element, {
            type: element.dataset.loop === 'true' ? 'loop' : 'slide',
            arrows: element.dataset.arrows === 'true',
            pagination: false,
            easing: element.dataset.easing,
            speed: Number(element.dataset.speed),
            perMove: Number(element.dataset.perMove),
            autoplay: element.dataset.autoplay === 'true',
            interval: Number(element.dataset.interval),
            per_move: Number(element.dataset.perMove),
            rewind: element.dataset.rewind === 'true',
            mediaQuery: 'min',
            breakpoints: {
                0: { perPage: Number(element.dataset.breakpointXs), padding: '30%' },
                576: { perPage: Number(element.dataset.breakpointSm), padding: 0 },
                768: { perPage: Number(element.dataset.breakpointMd), padding: 0 },
                992: { perPage: Number(element.dataset.breakpointLg), padding: 0 },
                1200: { perPage: Number(element.dataset.breakpointXl), padding: 0 },
                1400: { perPage: Number(element.dataset.breakpointXxl), padding: 0 }
            }
        })

        mySplide.mount()
    })
}
initIngredientSlider()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.ingredient-slider')) {
        initIngredientSlider()
    }
})

/*
    Favorite Bar Slider
*/
const initFavoriteBarSlider = () => {
    document.querySelectorAll('.favorite-bar-slider').forEach(section => {
        section.querySelectorAll('.main-splide').forEach(mainSplideEl => {
            const main = new Splide(mainSplideEl, {
                type: 'loop',
                arrows: false,
                pagination: false,
                easing: mainSplideEl.dataset.easing,
                speed: Number(mainSplideEl.dataset.speed),
                perMove: Number(mainSplideEl.dataset.perMove),
                autoplay: mainSplideEl.dataset.autoplay === 'true',
                interval: Number(mainSplideEl.dataset.interval),
                per_move: Number(mainSplideEl.dataset.perMove),
                rewind: mainSplideEl.dataset.rewind === 'true',
                mediaQuery: 'min',
                breakpoints: {
                    0: { perPage: 1, padding: '15%' },
                    576: { perPage: 1, padding: '15%' },
                    768: { perPage: 1, padding: '15%' },
                    992: { perPage: 1, padding: '15%' },
                    1200: { perPage: 1, padding: '15%' },
                    1400: { perPage: 1, padding: '15%' }
                }
            })

            const thumbs = new Splide(mainSplideEl.closest('.tab-pane').querySelector('.thumbs-splide'), {
                type: 'loop',
                gap: '1rem',
                rewind: true,
                rewindByDrag: true,
                arrows: true,
                pagination: false,
                isNavigation: true,
                perPage: 3,
                focus: 'center',
                fixedWidth: '70px',
                fixedHeight: '70px',
                padding: 0
            })

            main.sync(thumbs)
            main.mount()
            thumbs.mount()

            setTimeout(() => {
                thumbs.refresh()
            }, 200)

            section.querySelectorAll('.nav-tabs button').forEach(btn => {
                btn.addEventListener('show.bs.tab', event => {
                    section.querySelectorAll('.nav-tabs button').forEach(btn => {
                        btn.classList.remove('btn-styled', 'btn-primary')
                    })
                    event.target.classList.add('btn-styled', 'btn-primary')

                    setTimeout(() => {
                        main.refresh()
                        thumbs.refresh()
                    }, 200)
                })
            })
        })
    })
}
initFavoriteBarSlider()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.favorite-bar-slider')) {
        initFavoriteBarSlider()
    }
})

/*
    PDP Ingredients Pack slider
*/
const initPdpIngredientPackSlider = () => {
    document.querySelectorAll('.pdp-ingredients-pack').forEach(section => {
        const element = section.querySelector('.splide')

        const mySplide = new Splide(element, {
            // type: 'loop',
            pagination: true,
            per_move: 1,
            rewind: true,
            mediaQuery: 'min',
            breakpoints: {
                0: { perPage: Number(element.dataset.breakpointXs), arrows: true },
                576: { perPage: Number(element.dataset.breakpointSm), arrows: false },
                768: { perPage: Number(element.dataset.breakpointMd), arrows: false },
                992: { perPage: Number(element.dataset.breakpointLg), arrows: false },
                1200: { perPage: Number(element.dataset.breakpointXl), arrows: false },
                1400: { perPage: Number(element.dataset.breakpointXxl), arrows: false }
            }
        })

        mySplide.mount()
    })
}
initPdpIngredientPackSlider()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.pdp-ingredients-pack')) {
        initPdpIngredientPackSlider()
    }
})

/*
    Marquee
*/
const initMarqueeSections = () => {
    document.querySelectorAll('.marquee').forEach(section => {
        const list = section.querySelector('ul')
        const marqueeWidth = list.scrollWidth
        const marqueeLength = list.querySelectorAll('li').length

        list.insertAdjacentHTML('beforeEnd', list.innerHTML)
        list.insertAdjacentHTML('beforeEnd', list.innerHTML)

        list.querySelectorAll('li').forEach((item, index) => {
            if (index >= marqueeLength) {
                item.setAttribute('aria-hidden', 'true')
            }
        })

        let style = `
            <style>
                #marquee-${list.dataset.sectionId} ul {
                    animation-name: marquee-animation-${list.dataset.sectionId};
                    animation-duration: ${list.dataset.animationDuration}s;
                }
                @keyframes marquee-animation-${list.dataset.sectionId} {
                    to { transform: translateX(-${marqueeWidth}px); }
                }
            </style>
        `
        if (list.dataset.marqueeDirection === 'right') {
            style += `
                <style>
                    @keyframes marquee-animation-${list.dataset.sectionId} {
                        from { transform: translateX(-${marqueeWidth}px); }    
                        to { transform: 0); }    
                    }
                </style>
            `
        }

        list.insertAdjacentHTML('beforeBegin', style)
    })
}
initMarqueeSections()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.marquee')) {
        initMarqueeSections()
    }
})

/*
    Testimonials
*/
const initTestimonials = () => {
    document.querySelectorAll('.testimonials').forEach(section => {
        const element = section.querySelector('.splide')

        const mySplide = new Splide(element, {
            type: element.dataset.loop === 'true' ? 'loop' : 'slide',
            arrows: element.dataset.arrows === 'true',
            pagination: false,
            easing: element.dataset.easing,
            speed: Number(element.dataset.speed),
            perMove: Number(element.dataset.perMove),
            autoplay: element.dataset.autoplay === 'true',
            interval: Number(element.dataset.interval),
            per_move: Number(element.dataset.perMove),
            rewind: element.dataset.rewind === 'true',
            mediaQuery: 'min',
            breakpoints: {
                0: { perPage: Number(element.dataset.breakpointXs), padding: '10%' },
                576: { perPage: Number(element.dataset.breakpointSm), padding: 0 },
                768: { perPage: Number(element.dataset.breakpointMd), padding: 0 },
                992: { perPage: Number(element.dataset.breakpointLg), padding: 0 },
                1200: { perPage: Number(element.dataset.breakpointXl), padding: 0 },
                1400: { perPage: Number(element.dataset.breakpointXxl), padding: 0 }
            }
        })

        mySplide.mount()
    })
}
initTestimonials()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.testimonials')) {
        initTestimonials()
    }
})

/*
    Press
*/
const initPress = () => {
    document.querySelectorAll('.press-section').forEach(section => {
        const element = section.querySelector('.splide')

        const mySplide = new Splide(element, {
            type: element.dataset.loop === 'true' ? 'loop' : 'slide',
            arrows: false,
            pagination: true,
            easing: element.dataset.easing,
            speed: Number(element.dataset.speed),
            perMove: Number(element.dataset.perMove),
            autoplay: element.dataset.autoplay === 'true',
            interval: Number(element.dataset.interval),
            per_move: Number(element.dataset.perMove),
            rewind: element.dataset.rewind === 'true',
            mediaQuery: 'min',
            breakpoints: {
                0: { perPage: Number(element.dataset.breakpointXs), padding: '10%' },
                576: { perPage: Number(element.dataset.breakpointSm), padding: 0 },
                768: { perPage: Number(element.dataset.breakpointMd), padding: 0 },
                992: { perPage: Number(element.dataset.breakpointLg), padding: 0 },
                1200: { perPage: Number(element.dataset.breakpointXl), padding: 0 },
                1400: { perPage: Number(element.dataset.breakpointXxl), padding: 0 }
            }
        })

        mySplide.mount()
    })
}
initPress()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.press-section')) {
        initPress()
    }
})

/*
    Certifications Slider
*/
const initCertificationsSlider = () => {
    document.querySelectorAll('.certifications-slider').forEach(section => {
        const element = section.querySelector('.splide')

        const mySplide = new Splide(element, {
            type: element.dataset.loop === 'true' ? 'loop' : 'slide',
            arrows: element.dataset.arrows === 'true',
            pagination: element.dataset.pagination === 'true',
            easing: element.dataset.easing,
            speed: Number(element.dataset.speed),
            perMove: Number(element.dataset.perMove),
            autoplay: element.dataset.autoplay === 'true',
            interval: Number(element.dataset.interval),
            rewind: element.dataset.rewind === 'true',
            mediaQuery: 'min'
        })

        mySplide.mount()
    })
}
initCertificationsSlider()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.certifications-slider')) {
        initCertificationsSlider()
    }
})

/*
    Video Slider
*/
const initVideoSlider = () => {
    document.querySelectorAll('.video-slider').forEach(section => {
        const element = section.querySelector('.splide')

        const mySplide = new Splide(element, {
            arrows: true,
            pagination: false,
            perPage: 1,
            rewind: true
        })

        mySplide.mount()
    })
}
initVideoSlider()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.video-slider')) {
        initVideoSlider()
    }
})

/*
    Sticky ATC
*/
const initStickyAtc = async () => {
    const wrapper = document.querySelector('#sticky-atc')

    if (!wrapper) return

    await new Promise(resolve => setTimeout(resolve, 1000))

    const threshold = document.querySelector('.product-content .form-wrapper').getBoundingClientRect().bottom + window.scrollY

    window.addEventListener('scroll', () => {
        if (window.scrollY > threshold) {
            wrapper.classList.add('show')
            document.body.style.paddingBottom = wrapper.clientHeight + 'px'
        } else {
            wrapper.classList.remove('show')
            document.body.style.paddingBottom = 0
        }
    })
}
initStickyAtc()

/*
    Recommended Products
    https://shopify.dev/themes/product-merchandising/recommendations
*/
const initRecommendedProducts = async () => {
    const section = document.querySelector('.recommended-products')

    if (!section) return

    const { sectionId, baseUrl, productId, limit, intent } = section.dataset
    const url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}&intent=${intent}`
    const response = await fetch(url)
    const data = await response.text()

    section.closest('.shopify-section').outerHTML = data

    document.querySelectorAll('.recommended-products [data-bs-toggle="popover"]')
        .forEach((el) => bootstrap.Popover.getOrCreateInstance(el))

    const customEvent = new CustomEvent('init.ecomify.recommended_products')
    window.dispatchEvent(customEvent)
}
initRecommendedProducts()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.recommended-products')) {
        initRecommendedProducts()
    }
})
